import { render, staticRenderFns } from "./DetailCursos.vue?vue&type=template&id=047fb7dc&scoped=true&"
import script from "./DetailCursos.vue?vue&type=script&lang=js&"
export * from "./DetailCursos.vue?vue&type=script&lang=js&"
import style0 from "./DetailCursos.vue?vue&type=style&index=0&id=047fb7dc&lang=scss&scoped=true&"
import style1 from "./DetailCursos.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047fb7dc",
  null
  
)

export default component.exports